import script from "./FortuneOps.vue?vue&type=script&setup=true&lang=js"
export * from "./FortuneOps.vue?vue&type=script&setup=true&lang=js"

import "./FortuneOps.vue?vue&type=style&index=0&id=332d5bd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332d5bd4"]])

export default __exports__